var map = {
	"./2_pc.webp": 9331,
	"./Admisiones.png": 9870,
	"./Financiera.webp": 4256,
	"./Idiomas.webp": 9152,
	"./Inter.webp": 6489,
	"./Rector.webp": 6158,
	"./Vice.webp": 1990,
	"./biblioteca.webp": 4130,
	"./campus.webp": 4247,
	"./estudiantes.webp": 7022,
	"./fotocie.jpg": 8326,
	"./paso_digital.webp": 7373,
	"./practica_graduados.webp": 3029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2104;